/* ==========================================================================
   Kollektioner 2.0 — ishockey (2026-10-18, runda 2)

   · Färdiga paket (snippets/tp-hockey-aid.liquid): välj paket, anpassa
     delar under "Anpassa paketet", hela paketet i varukorgen via
     window.TPCart.add (enda korgvägen i temat).
   · Paketraden i sidhuvudet (data-tp-hk-pack-jump): väljer paketet och
     rullar ner. Adressen #tp-hk-pack-2 gör samma sak från en länk.
   · Puckguiden: flikar (piltangenter, Home/End) och "Visa alla".
   · Snabbval med data-tp-hk-jump: rullar till guiden och väljer flik
     (#tp-hk-aid-match från en annan sida).

   Rutnätet ritas om av filtren (tp-filters.js) och "Visa fler" — allt
   lyssnar därför på document och inget sparas per element.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__tpHockeyReady) return;
  window.__tpHockeyReady = true;

  function money(cents) {
    var whole = Math.round(cents) % 100 === 0;
    try {
      return new Intl.NumberFormat('sv-SE', {
        style: 'currency',
        currency: 'SEK',
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2
      }).format(cents / 100);
    } catch (e) {
      return Math.round(cents / 100) + ' kr';
    }
  }

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function scrollToEl(el, smooth) {
    el.scrollIntoView({ behavior: smooth && !reduced() ? 'smooth' : 'auto', block: 'start' });
    var title = el.querySelector('h2[tabindex]');
    if (title) {
      try { title.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  /* ---- Färdiga paket ------------------------------------------------------ */
  function currentIndex(box) {
    var picked = box.querySelector('[data-tp-hk-pick]:checked');
    return picked ? picked.value : '0';
  }

  function currentSet(box) {
    return box.querySelector('[data-tp-hk-set="' + currentIndex(box) + '"]');
  }

  function chosenOptions(set) {
    if (!set) return [];
    return Array.prototype.slice.call(set.querySelectorAll('[data-tp-hk-part]')).map(function (select) {
      return select.options[select.selectedIndex];
    }).filter(function (option) {
      return option && option.value;
    });
  }

  function update(box) {
    var index = currentIndex(box);
    box.querySelectorAll('[data-tp-hk-set]').forEach(function (set) {
      set.hidden = set.getAttribute('data-tp-hk-set') !== index;
    });
    var set = currentSet(box);
    var chosen = chosenOptions(set);
    var total = chosen.reduce(function (sum, option) { return sum + Number(option.getAttribute('data-price') || 0); }, 0);
    var names = chosen.map(function (option) { return option.getAttribute('data-name') || ''; }).join(' · ');

    /* Kortet visar det man faktiskt får: innehåll och summa efter Anpassa. */
    var pick = box.querySelector('[data-tp-hk-pick]:checked');
    var card = pick && pick.parentNode;
    if (card) {
      var items = card.querySelector('[data-tp-hk-pk-items]');
      var price = card.querySelector('[data-tp-hk-pk-price]');
      if (items) items.textContent = names || 'Inget valt';
      if (price) price.textContent = money(total);
    }
    var sum = box.querySelector('[data-tp-hk-total]');
    if (sum) sum.textContent = money(total);
    var add = box.querySelector('[data-tp-hk-add]');
    if (add) add.disabled = chosen.length === 0;
  }

  function resetMessage(box) {
    var msg = box.querySelector('[data-tp-hk-msg]');
    if (msg) {
      msg.textContent = '';
      msg.removeAttribute('data-tp-hk-state');
    }
  }

  /* Med ett filter valt ritar tp-filters.js om rutnätet utan paketraden.
     Då göms paketraden i sidhuvudet också, och kommer tillbaka utan filter. */
  function initPacks(root) {
    (root || document).querySelectorAll('[data-tp-hk-packs]').forEach(update);
    var nav = document.querySelector('.tp-hk-find--packs');
    if (nav) nav.hidden = !document.querySelector('[data-tp-hk-packs]');
  }

  document.addEventListener('change', function (event) {
    var box = event.target.closest && event.target.closest('[data-tp-hk-packs]');
    if (!box) return;
    resetMessage(box);
    update(box);
  });

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('[data-tp-hk-custom-toggle]');
    if (!toggle) return;
    var box = toggle.closest('[data-tp-hk-packs]');
    var panel = box && box.querySelector('.tp-hk-custom');
    if (!panel) return;
    var open = panel.hidden;
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.textContent = open ? 'Stäng' : 'Anpassa paketet';
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-tp-hk-add]');
    if (!button) return;
    var box = button.closest('[data-tp-hk-packs]');
    if (!box) return;
    var items = chosenOptions(currentSet(box)).map(function (option) {
      return { id: Number(option.value), quantity: 1 };
    });
    if (!items.length) return;
    var msg = box.querySelector('[data-tp-hk-msg]');

    function say(text, state) {
      if (!msg) return;
      msg.textContent = text;
      msg.setAttribute('data-tp-hk-state', state);
    }

    if (!window.TPCart || typeof window.TPCart.add !== 'function') {
      say('Det gick inte att lägga i varukorgen just nu. Försök igen om en stund.', 'error');
      return;
    }

    Promise.resolve(window.TPCart.add(items, { source: 'hockey-paket', trigger: button }))
      .then(function (result) {
        if (result === null) return;
        say('Paketet ligger i varukorgen.', 'ok');
      })
      .catch(function (error) {
        if (error && error.tpSoldOut) {
          say('En del tog slut alldeles nyss. Byt den under Anpassa paketet.', 'error');
        } else {
          say((error && error.message) || 'Det gick inte att lägga i varukorgen. Försök igen.', 'error');
        }
      });
  });

  function selectPack(index, smooth) {
    var box = document.querySelector('[data-tp-hk-packs]');
    if (!box) return false;
    var input = box.querySelector('[data-tp-hk-pick][value="' + index + '"]');
    if (input && !input.checked) {
      input.checked = true;
      resetMessage(box);
      update(box);
    }
    if (input) {
      var card = input.parentNode;
      var rail = card && card.parentNode;
      if (rail && rail.scrollWidth > rail.clientWidth) rail.scrollLeft = card.offsetLeft - rail.offsetLeft;
    }
    scrollToEl(box, smooth);
    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-tp-hk-pack-jump]');
    if (!link) return;
    if (!document.querySelector('[data-tp-hk-packs]')) return;
    event.preventDefault();
    selectPack(link.getAttribute('data-tp-hk-pack-jump') || '0', true);
  });

  /* "Köp" i puckguiden och jämförelsen: kort bekräftelse på knappen.
     Själva köpet går genom TPCart (formuläret eller variantarket). */
  document.addEventListener('tp:cart:added', function (event) {
    var trigger = event.detail && event.detail.trigger;
    if (!trigger || !trigger.classList) return;
    if (!trigger.classList.contains('tp-hk-buy') && !trigger.classList.contains('tp-hk-cmp__buy')) return;
    if (!trigger.hasAttribute('data-tp-hk-label')) trigger.setAttribute('data-tp-hk-label', trigger.textContent);
    trigger.classList.add('is-added');
    trigger.textContent = 'Tillagd';
    window.setTimeout(function () {
      trigger.classList.remove('is-added');
      trigger.textContent = trigger.getAttribute('data-tp-hk-label') || 'Köp';
    }, 1800);
  });

  /* ---- Puckguiden: flikar och "Visa alla" ---------------------------------- */
  function selectTab(box, key, focus) {
    var tabs = Array.prototype.slice.call(box.querySelectorAll('[data-tp-hk-tab]'));
    var target = tabs.filter(function (t) { return t.getAttribute('data-tp-hk-tab') === key; })[0];
    if (!target) return false;
    tabs.forEach(function (tab) {
      var on = tab === target;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) tab.removeAttribute('tabindex');
      else tab.setAttribute('tabindex', '-1');
    });
    box.querySelectorAll('[data-tp-hk-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-tp-hk-panel') !== key;
    });
    if (focus) target.focus();
    return true;
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest && event.target.closest('[data-tp-hk-tab]');
    if (!tab) return;
    var box = tab.closest('[data-tp-hk-tabs]');
    if (box) selectTab(box, tab.getAttribute('data-tp-hk-tab'), false);
  });

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest && event.target.closest('[data-tp-hk-tab]');
    if (!tab) return;
    var box = tab.closest('[data-tp-hk-tabs]');
    if (!box) return;
    var tabs = Array.prototype.slice.call(box.querySelectorAll('[data-tp-hk-tab]'));
    var i = tabs.indexOf(tab);
    var next = -1;
    if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
    else if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;
    if (next < 0) return;
    event.preventDefault();
    selectTab(box, tabs[next].getAttribute('data-tp-hk-tab'), true);
  });

  document.addEventListener('click', function (event) {
    var more = event.target.closest && event.target.closest('[data-tp-hk-more]');
    if (!more) return;
    var panel = more.closest('[data-tp-hk-panel]');
    if (!panel) return;
    var open = more.getAttribute('aria-expanded') !== 'true';
    panel.querySelectorAll('[data-tp-hk-extra]').forEach(function (row) { row.hidden = !open; });
    more.setAttribute('aria-expanded', open ? 'true' : 'false');
    more.textContent = open ? 'Visa färre' : (more.getAttribute('data-tp-hk-more-label') || 'Visa alla');
  });

  /* ---- Snabbval till guiden ------------------------------------------------ */
  function jump(key, smooth) {
    var aid = document.getElementById('tp-hk-aid');
    if (!aid) return false;
    if (key && aid.hasAttribute('data-tp-hk-tabs')) selectTab(aid, key, false);
    scrollToEl(aid, smooth);
    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-tp-hk-jump]');
    if (!link) return;
    if (!document.getElementById('tp-hk-aid')) return;
    event.preventDefault();
    jump(link.getAttribute('data-tp-hk-jump') || '', true);
  });

  function fromHash() {
    var hash = (window.location.hash || '').replace('#', '');
    if (hash.indexOf('tp-hk-pack') === 0) {
      selectPack(hash.slice('tp-hk-pack'.length).replace(/^-/, '') || '0', false);
    } else if (hash.indexOf('tp-hk-aid') === 0) {
      jump(hash.slice('tp-hk-aid'.length).replace(/^-/, ''), false);
    }
  }

  function ready() {
    initPacks(document);
    if (window.location.hash) window.setTimeout(fromHash, 60);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();

  document.addEventListener('tp:grid-updated', function () { initPacks(document); });
})();
